import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { Redirect } from 'react-router-dom';

import { ButtonLink, LoginTemplate } from 'components';
import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './CtRegisterComplete.css';
const cx = classNames.bind(styles);

class CtRegisterComplete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { register } = this.props;
    const registerData = register.toJS();

    if (!registerData.isRegister) {
      return (
        <Redirect
          to={{
            pathname: '/register'
          }}
        />
      );
    }

    return (
      <LoginTemplate>
        <div className={cx('ctRegisterComplete-wrapper')}>
          <div className={cx('registerComplete-area')}>
            <div className={cx('registerComplete-area-content')}>
              <div className={cx('registerComplete-area-content-welcome')}>
                {defineMessages(
                  formatMessage({ id: 'CtRegisterComplete_1', defaultMessage: 'MudFix 가입을 환영합니다 !' })
                )}
              </div>
              <div className={cx('registerComplete-area-content-info')}>
                {defineMessages(
                  formatMessage({
                    id: 'CtRegisterComplete_2',
                    defaultMessage: '가입한 이메일로 본인 확인 메일이 전송되었습니다.'
                  })
                )}
                <br />
                {defineMessages(
                  formatMessage({
                    id: 'CtRegisterComplete_3',
                    defaultMessage: '인증 메일은 가입 신청일로부터 3일 이내에 확인해주세요.'
                  })
                )}
              </div>
              <div className={cx('registerComplete-area-content-middle')}>
                <div className={cx('registerComplete-area-content-middle-email')}>
                  <span>
                    {defineMessages(formatMessage({ id: 'CtRegisterComplete_4', defaultMessage: '등록된 메일 주소' }))}
                  </span>
                  <span>{registerData.userEmail}</span>
                </div>
              </div>
              <div className={cx('registerComplete-area-content-bottom')}>
                <div className={cx('ui button bt-signUp')}>
                  <ButtonLink
                    activeOnlyWhenExact={false}
                    to="/login"
                    label={defineMessages(formatMessage({ id: 'CtRegisterComplete_5', defaultMessage: '확인' }))}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

CtRegisterComplete.propTypes = {};
CtRegisterComplete.defaultProps = {};

const mapStateToProps = state => ({
  register: state.register.get('register')
});

export default connect(mapStateToProps)(injectIntl(CtRegisterComplete));



// WEBPACK FOOTER //
// ./src/script/containers/register/CtRegisterComplete.js